import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent, PiStudentBold } from "react-icons/pi";
import { callApi, CDN_URL, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher, FaChevronDown } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import OneOutstandingPaymentCycle from "../ones/OneOutstandingPaymentCycle";
import OnePaymentRecord from "../ones/OnePaymentRecord";
import OneOutstandingDebt from "../ones/OneOutstandingDebt";
import OneDiscount from "../ones/OneDiscount";
import { MdDelete } from "react-icons/md";
import DebtRegistrationForm from "../ones/DebtRegistrationForm";
import DiscountRegistrationForm from "../ones/DiscountRegistrationForm";

export default function View({ uuid }) {
  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);
  const [data, setData] = useState(null);
  const [paymentsProfile, setPaymentsProfile] = useState(null);
  const [loading, setLoading] = useState(false);

  const [bulkReceiptId, setBulkReceiptId] = useState('');
  const [bulkPaymentCollections, setBulkPaymentCollections] = useState([]);
  const [bulkPayWith, setBulkPayWith] = useState("bank");
	const [bulkPaymentDate, setBulkPaymentDate] = useState("");
  const [bulkTotal, setBulkTotal] = useState(0);

  
  async function init() {
    //run initializations here
    setReady(false);
    await Promise.all([
      getData(),
      getPaymentsProfile(),
    ]);
    setReady(true);
  }

  function addBulkPaymentCollection() {
    const _temp = {
      amount: 0,
      cycleType: 'general',
      cycleUuid: ''
    };

    setBulkPaymentCollections(_prev => {
      const _new = [..._prev];

      _new.push(_temp);

      return _new;
    })
  }

  function editBulkPaymentCollection(index, field, value) {
    
    setBulkPaymentCollections(_prev => {
      const _new = [..._prev];
      const _item = _new[index];

      if(field === 'amount') {
        if(!isNaN(Number(value))) {
          _item[field] = Number(value);
        }
      } else {
        _item[field] = value;
      }

      return _new;
    })
  }

  function deleteBulkPaymentCollection(index) {
    
    setBulkPaymentCollections(_prev => {
      const _new = [..._prev];

      _new.splice(index, 1);

      return _new;
    })
  }

  async function getData() {
    await callApi("get-student-data", { uuid }).then(response => {
      if (response.status === 1) {
        setData(response.data);
      } else {
        appContext.tellError("Could not fetch data, check your connection");
      }
    })
  }

  async function getPaymentsProfile() {
    await callApi("get-student-payments-profile", { uuid }).then(response => {
      if (response.status === 1) {
        setPaymentsProfile(response.data);
      } else {
        appContext.tellError("Could not fetch data, check your connection");
      }
    })
  }

  function validateBulkPaymentCollections() {
    let _isValid = false;

    if (bulkPaymentCollections && bulkPaymentCollections.length > 0) {
      let _allItemsClear = true;
      const seenUuids = new Set();

      for (const item of bulkPaymentCollections) {
        const isItemValid =
          !isNaN(item.amount) &&
          Number(item.amount) > 0 &&
          item.cycleType &&
          item.cycleUuid &&
          item.cycleUuid.trim().length > 0;

        if (!isItemValid) {
          _allItemsClear = false;
          break;
        }

        // 🔴 prevent duplicate UUIDs
        if (seenUuids.has(item.cycleUuid)) {
          _allItemsClear = false;
          break;
        }

        seenUuids.add(item.cycleUuid);
      }

      if (_allItemsClear) {
        _isValid = true;
      }
    }

    if (_isValid) {
      return true;
    } else {
      appContext.tellError(
        "Please set your collection list correctly. Duplicate payment cycles are not allowed."
      );
      return false;
    }
  }


  function getBulkTotal() {
    let _total = 0;

    if(bulkPaymentCollections) {
      for (const item of bulkPaymentCollections) {
        _total += Number(item.amount);
      }
    }
    setBulkTotal(_total);
  }

  async function submitBulkPaymentCollections() {
    const bulkReceiptFile = document.getElementById("_bulkReceiptFile").files[0];

    if(bulkReceiptId && bulkReceiptId.trim().length > 0) {
      if(validateBulkPaymentCollections()) {
        if(bulkPayWith && bulkPayWith.trim().length > 0) {
          if(bulkPaymentDate && bulkPaymentDate.trim().length > 0) {
            setLoading(true);
            await callApi(
              'create-bulk-payment-record',
              {
								bulkPayWith,
								bulkReceiptId,
								bulkReceiptFile: (bulkReceiptFile || ''),
								bulkPaymentDate,
								schoolUuid: appContext.currentSchoolUuid,
								studentUuid: uuid,
                bulkPaymentCollectionsString: JSON.stringify(bulkPaymentCollections),
              }
            ).then(response => {
							if(response.status === 1) {
								appContext.tellMessage("Payments were received");
								init();
                setBulkReceiptId('');
                setBulkPayWith('');
                setBulkPaymentDate('');
                setBulkPaymentCollections([]);
                document.getElementById("_bulkReceiptFile").value = '';
							} else {
								appContext.tellError(response.msg);
							}
						})
            setLoading(false);
          } else {
            appContext.tellError("Please enter payment date");
          }
        } else {
          appContext.tellError("Please select payment method");
        }
      } else {
        //message handled
      }
    } else {
      appContext.tellError("Receipt ID is Required");
    }
  }

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);

    return () => {
      appContext.setShowOverlayLoader(false);
    }
  }, [loading])

  

  useEffect(() => {
    getBulkTotal();
  }, [ bulkPaymentCollections ])

  if (ready && data && paymentsProfile) {
    return (
      <div className="container">
        <div className="row">

          <div className="col-12 mb-4">
            <h6 className="main-section-title">
              Payments' Profile for {data.firstName} {data.middleName} {data.lastName}
              <br/>
              <span className="badge bg-primary">Student</span>
            </h6>
            <hr/>
          </div>

          <div className="col-md-12 mt-2 mb-2">
            <div
              style={{
                width: "150px",
                height: "150px",
                margin: "0 auto",
                borderRadius: "20px",
                overflow: "hidden",
                cursor: "pointer",
                overflow: "hidden",
              }}
              className="bg-surface mShadow1"
            >
              {
                (data.passportPic) ?
                <img
                  src={CDN_URL + data.passportPic}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                />
                :
                <PiStudentBold
                  style={{
                    width: "100%",
                    height: "100%"
                  }}
                  className="text-muted"
                />
              }
            </div>
          </div>

          <div className="col-md-4 col-6 mt-2 mb-2">
            <label className="form-label">First Name</label>
            <h6 style={{ fontSize: "18px" }}>
              {data.firstName || "N/A"}
            </h6>
          </div>

          <div className="col-md-4 col-6 mt-2 mb-2">
            <label className="form-label">Middle Name</label>
            <h6 style={{ fontSize: "18px" }}>
              {data.middleName || "N/A"}
            </h6>
          </div>

          <div className="col-md-4 col-6 mt-2 mb-2">
            <label className="form-label">Last Name</label>
            <h6 style={{ fontSize: "18px" }}>
              {data.lastName || "N/A"}
            </h6>
          </div>
          
          <div className="col-md-4 col-6 mt-2 mb-2">
            <label className="form-label">Classrooom</label>
            <h6 style={{ fontSize: "18px" }}>
              {data.classroomName || "N/A"}
            </h6>
          </div>

          <div className="col-md-4 col-6 mt-2 mb-2">
            <label className="form-label">Stream</label>
            <h6 style={{ fontSize: "18px" }}>
              {data.streamName || "N/A"}
            </h6>
          </div>

          <div className="col-md-4 col-6 mt-2 mb-2">
            <label className="form-label">Date of Birth</label>
            <h6 style={{ fontSize: "18px" }}>
              {data.birthDate || "N/A"}
            </h6>
          </div>

          {/* Payments Profile Summary */}
          <div className="col-md-12 mt-2 mb-2">
            <div className="card">
              <div className="card-body">
                <div
                  className="d-flex justify-content-between"
                >
                  <h6 className="card-title align-self-center mb-4">Payments' Profile Summary</h6>
                </div>
                <div className="row" id="_studentSection1">
                  
                  
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h6
                          className="mt-4 mb-4 text-danger"
                          style={{ fontSize: "28px" }}
                        >
                          {formatMoney(paymentsProfile.totalDebt)}
                          <span style={{ fontSize: "14px" }} className="d-block">
                            TZS
                          </span>
                        </h6>
                        <h6
                          style={{
                            fontSize: "14PX"
                          }}
                          className="font-bold text-danger"
                        >
                          Total Outstanding Debt
                        </h6>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h6
                          className="mt-4 mb-4"
                          style={{ fontSize: "28px" }}
                        >
                          {formatMoney(paymentsProfile.totalDiscount)}
                          <span style={{ fontSize: "14px" }} className="d-block">
                            TZS
                          </span>
                        </h6>
                        <h6
                          style={{
                            fontSize: "14PX"
                          }}
                          className="font-bold"
                        >
                          Total Issued Discount
                        </h6>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          {/* Outstanding General Payments */}
          <div className="col-md-12 mt-2 mb-2">
            <div className="card">
              <div className="card-body">
                <div
                  className="d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="collapse"
                  data-bs-target="#_studentSection2"
                  aria-expanded="false"
                  aria-controls="_studentSection2"
                >
                  <h6 className="card-title align-self-center">Outstanding General Payments</h6>
                  <FaChevronDown size={24} className="align-self-center text-primary" />
                </div>
                <div className="collapse" id="_studentSection2">
                  <hr/>
                  {
                    (paymentsProfile.outstandingGeneralPaymentCycles && paymentsProfile.outstandingGeneralPaymentCycles.length > 0) ?
                    paymentsProfile.outstandingGeneralPaymentCycles.map((item, i) => (
                      <OneOutstandingPaymentCycle studentUuid={uuid} type='general' data={item} key={i}/>
                    ))
                    :
                    <h6>No records were found</h6>
                  }
                </div>
              </div>
            </div>
          </div>

          {/* Outstanding Individual Payments */}
          <div className="col-md-12 mt-2 mb-2">
            <div className="card">
              <div className="card-body">
                <div
                  className="d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="collapse"
                  data-bs-target="#_studentSection3"
                  aria-expanded="false"
                  aria-controls="_studentSection3"
                >
                  <h6 className="card-title align-self-center">Outstanding Individual Payments</h6>
                  <FaChevronDown size={24} className="align-self-center text-primary" />
                </div>
                <div className="collapse" id="_studentSection3">
                  <hr/>
                  {
                    (paymentsProfile.outstandingIndividualPaymentCycles && paymentsProfile.outstandingIndividualPaymentCycles.length > 0) ?
                    paymentsProfile.outstandingIndividualPaymentCycles.map((item, i) => (
                      <OneOutstandingPaymentCycle studentUuid={uuid} type='individual' data={item} key={i}/>
                    ))
                    :
                    <h6>No records were found</h6>
                  }
                </div>
              </div>
            </div>
          </div>

          {/* Other outstanding debts */}
          <div className="col-md-12 mt-2 mb-2">
            <div className="card">
              <div className="card-body">
                <div
                  className="d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="collapse"
                  data-bs-target="#_studentSection31"
                  aria-expanded="false"
                  aria-controls="_studentSection31"
                >
                  <h6 className="card-title align-self-center">Other Outstanding Debts</h6>
                  <FaChevronDown size={24} className="align-self-center text-primary" />
                </div>
                <div className="collapse" id="_studentSection31">
                  <hr/>

                  {
                    (paymentsProfile.outstandingDebts && paymentsProfile.outstandingDebts.length > 0) ?
                    paymentsProfile.outstandingDebts.map((item, i) => (
                      <OneOutstandingDebt studentUuid={uuid} data={item} key={i}/>
                    ))
                    :
                    <h6>No records were found</h6>
                  }
                </div>
              </div>
            </div>
          </div>

          {/* Record other debts */}
          <div className="col-md-12 mt-2 mb-2">
            <div className="card">
              <div className="card-body">
                <div
                  className="d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="collapse"
                  data-bs-target="#_studentSection311"
                  aria-expanded="false"
                  aria-controls="_studentSection311"
                >
                  <h6 className="card-title align-self-center">Record Other Debts</h6>
                  <FaChevronDown size={24} className="align-self-center text-primary" />
                </div>
                <div className="collapse" id="_studentSection311">
                  <hr/>

                  <div className="">
                    <DebtRegistrationForm
                      studentUuid={uuid}
                      callback={getPaymentsProfile}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bulk Payments Collector */}
          <div className="col-md-12 mt-2 mb-2">
            <div className="card">
              <div className="card-body">
                <div
                  className="d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="collapse"
                  data-bs-target="#_studentSection5"
                  aria-expanded="false"
                  aria-controls="_studentSection5"
                >
                  <h6 className="card-title align-self-center">Bulk Payments Collection By Receipt</h6>
                  <FaChevronDown size={24} className="align-self-center text-primary" />
                </div>
                <div className="collapse" id="_studentSection5">
                  <hr/>
                  <div 
                    className="row"
                  >

                    <div className="col-md-12 mt-2 mb-2">
                      <label className="form-label">Receipt ID</label>
                      <input
                        className="form-control"
                        value={bulkReceiptId}
                        onChange={(e) => setBulkReceiptId(e.target.value)}
                      />
                    </div>

                    <div className="col-md-12 mt-2 mb-2">
                      <label className="form-label">Receipt File</label>
                      <input
                        className="form-control"
                        type="file"
                        id="_bulkReceiptFile"
                      />
                      <div className="form-text">Optional</div>
                    </div>
                    
                    <div className="col-md-6 mt-2 mb-2">
                      <label className="form-label">Payment Date</label>
                      <input
                        className="form-control"
                        value={bulkPaymentDate}
                        onChange={(e) => setBulkPaymentDate(e.target.value)}
                        type="date"
                      />
                    </div>

                    <div className="col-md-6 mt-2 mb-2">
                      <label className="form-label">Paid with</label>
                      <select
                        className="form-control"
                        value={bulkPayWith}
                        onChange={(e) => setBulkPayWith(e.target.value)}
                      >
                        <option value=""></option>
                        <option value="cash" >Cash</option>
                        <option value="bank" >Bank</option>
                        <option value="credit_card" >Credit Card</option>
                        <option value="mobile_money" >Mobile Money</option>
                      </select>
                    </div>

                    <div className="col-md-12 mt-2 mb-2">
                      <label className="form-label">Payments to collect through this receipt</label>

                      {
                        (bulkPaymentCollections && bulkPaymentCollections.length > 0) ?
                        bulkPaymentCollections.map((item, i) => {
                          return (
                            <div className="card" key={i}>
                              <div className="card-body">
                                <div className="row">
                                  
                                  

                                  <div className="mt-3 mb-3">
                                    <label className="form-label text-primary">Select Payment Cycle Type</label>
                                    <select
                                      className="form-control"
                                      value={item.cycleType}
                                      onChange={(e) => {
                                        editBulkPaymentCollection(i, 'cycleType', e.target.value);
                                        editBulkPaymentCollection(i, 'cycleUuid', ''); //reset uuid
                                      }}
                                    >
                                      <option value='general'>General Cycle</option>
                                      <option value='individual'>Individual Cycle</option>
                                      <option value='debt'>Debt</option>
                                    </select>
                                  </div>

                                  <div className="mt-3 mb-3">
                                    <label className="form-label text-primary">Select Payment Cycle</label>
                                    <select
                                      className="form-control"
                                      value={item.cycleUuid}
                                      onChange={(e) => {
                                        editBulkPaymentCollection(i, 'cycleUuid', e.target.value)
                                      }}
                                    >
                                      <option value=''></option>

                                      {
                                        (item.cycleType === 'general') ?
                                        paymentsProfile.outstandingGeneralPaymentCycles?.map((item, i) => {
                                          return (
                                            <option key={i} value={item.uuid} >{item.title} (Balance = {formatMoney(item.balance)})</option>
                                          )
                                        })
                                        :''
                                      }

                                      {
                                        (item.cycleType === 'individual') ?
                                        paymentsProfile.outstandingIndividualPaymentCycles?.map((item, i) => {
                                          return (
                                            <option key={i} value={item.uuid} >{item.title} (Balance = {formatMoney(item.balance)})</option>
                                          )
                                        })
                                        :''
                                      }

                                      {
                                        (item.cycleType === 'debt') ?
                                        paymentsProfile.outstandingDebts?.map((item, i) => {
                                          return (
                                            <option key={i} value={item.uuid} >{item.title} (Balance = {formatMoney(item.balance)})</option>
                                          )
                                        })
                                        :''
                                      }
                                    </select>
                                  </div>

                                  <div className="mt-3 mb-3">
                                    <label className="form-label text-primary">Amount to collect (TZS)</label>
                                    <input
                                      className="form-control"
                                      value={item.amount}
                                      onChange={(e) => {
                                        editBulkPaymentCollection(i, 'amount', e.target.value)
                                      }}
                                    />
                                  </div>

                                  <div className="mt-3 mb-3">
                                    <MdDelete
                                      size={32}
                                      className="text-danger"
                                      onClick={() => {
                                        deleteBulkPaymentCollection(i);
                                      }}
                                      style={{
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>

                                </div>
                              </div>
                            </div>
                          )
                        })
                        :
                        <h6>No collections, click the button below to add</h6>
                      }
                      <div className="text-end">
                        <label className="form-label text-muted">Total to be collected</label>
                        <h6
                          style={{
                            fontSize: "32px",
                          }}
                          className="font-semi-bold"
                        >
                          {formatMoney(bulkTotal)} TZS
                        </h6>

                        

                        <button
                          className="btn btn-sm btn-dark"
                          onClick={addBulkPaymentCollection}
                        >
                          Add Collection
                        </button>
                      </div>

                      <hr/>
                    </div>  

                    <div className="col-md-12 mt-2 mb-2">
                      <button
                        className="btn btn-secondary btn-rounded btn-block btn-padded"
                        onClick={() => {
                          appContext.activateDialog({
                            message: "These payments for this receipt ID will be recorded, continue?",
                            onConfirm: submitBulkPaymentCollections,
                          })
                        }}
                      >
                        SUBMIT PAYMENTS
                      </button>
                    </div>                  
                    
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Payment History */}
          <div className="col-md-12 mt-2 mb-2">
            <div className="card">
              <div className="card-body">
                <div
                  className="d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="collapse"
                  data-bs-target="#_studentSection4"
                  aria-expanded="false"
                  aria-controls="_studentSection4"
                >
                  <h6 className="card-title align-self-center">Payments History</h6>
                  <FaChevronDown size={24} className="align-self-center text-primary" />
                </div>
                <div className="collapse" id="_studentSection4">
                  <hr/>
                  {
                    (paymentsProfile.allPaymentRecords && paymentsProfile.allPaymentRecords.length > 0) ?
                    paymentsProfile.allPaymentRecords.map((item, i) => (
                      <OnePaymentRecord data={item} key={i}/>
                    ))
                    :
                    <h6>No record was found</h6>
                  }
                </div>
              </div>
            </div>
          </div>

          {/* Record discount */}
          <div className="col-md-12 mt-2 mb-2">
            <div className="card">
              <div className="card-body">
                <div
                  className="d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="collapse"
                  data-bs-target="#_studentSection3111"
                  aria-expanded="false"
                  aria-controls="_studentSection3111"
                >
                  <h6 className="card-title align-self-center">Issue Discounts</h6>
                  <FaChevronDown size={24} className="align-self-center text-primary" />
                </div>
                <div className="collapse" id="_studentSection3111">
                  <hr/>

                  <div className="">
                    <DiscountRegistrationForm
                      studentUuid={uuid}
                      callback={getPaymentsProfile}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Discount History */}
          <div className="col-md-12 mt-2 mb-2">
            <div className="card">
              <div className="card-body">
                <div
                  className="d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="collapse"
                  data-bs-target="#_studentSection41"
                  aria-expanded="false"
                  aria-controls="_studentSection41"
                >
                  <h6 className="card-title align-self-center">Discount History</h6>
                  <FaChevronDown size={24} className="align-self-center text-primary" />
                </div>
                <div className="collapse" id="_studentSection41">
                  <hr/>
                  {
                    (paymentsProfile.allDiscounts && paymentsProfile.allDiscounts.length > 0) ?
                    paymentsProfile.allDiscounts.map((item, i) => (
                      <OneDiscount data={item} key={i}/>
                    ))
                    :
                    <h6>No discount was found</h6>
                  }
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}
